import type { ReactElement } from 'react';

const SPECS: readonly { readonly term: string; readonly detail: string }[] = [
  {
    term: '구도',
    detail: '제품만 정면으로 찍은 사진. 소품·모델·연출 배경 없이 제품이 화면 가운데에 오게 합니다.',
  },
  { term: '배경', detail: '흰색·연회색 같은 단색 밝은 배경, 또는 배경이 투명한 PNG를 권장합니다.' },
  {
    term: '크기·형식',
    detail:
      '정사각 2000×2000px 이상 권장. PNG·JPG(WebP 가능), 최대 10MiB · 가로·세로 20,000px 이하.',
  },
  {
    term: '색상마다',
    detail:
      '같은 면은 모든 색상 사진의 제품 위치·크기·각도를 똑같이 맞춥니다. 교체할 때도 같은 구도로 올립니다.',
  },
  {
    term: '면마다',
    detail:
      '앞면은 필수입니다. 뒷면·옆면 인쇄가 있으면 그 면을 켜고 따로 올리고, 한 면만 인쇄하는 상품은 뒷면을 꺼 둡니다.',
  },
  {
    term: '인쇄 부분',
    detail: '인쇄될 자리는 그림자·주름·반사를 최소로 해 주세요. 디자인이 그 위에 그대로 얹힙니다.',
  },
];

/**
 * 목업 이미지 업로드 안내 — 목업 사진이 무엇인지(고객 에디터의 디자인 배경, 상품 썸네일·대표 이미지와 별도)와
 * 권장 규격, 저장해야 반영된다는 점을 알린다.
 */
export const PhotoUploadNotice = (): ReactElement => (
  <aside
    aria-label="목업 이미지 안내"
    className="space-y-3 rounded-lg border bg-muted/40 p-4 text-sm"
  >
    <div className="space-y-1">
      <h3 className="font-semibold">목업 이미지란?</h3>
      <p className="text-muted-foreground">
        고객 커스터마이징 화면에서 디자인을 얹어 보여 주는 상품 사진입니다. 고객은 지금 고른
        색상·면의 목업 위에서 바로 편집합니다. 상품 목록의 썸네일·대표 이미지와는 별개이므로 색상 ×
        면마다 따로 올려 주세요.
      </p>
    </div>
    <dl className="grid gap-x-4 gap-y-1.5 sm:grid-cols-[max-content_1fr]">
      {SPECS.map((spec) => (
        <div key={spec.term} className="contents">
          <dt className="font-medium">{spec.term}</dt>
          <dd className="text-muted-foreground">{spec.detail}</dd>
        </div>
      ))}
    </dl>
    <p className="text-muted-foreground">
      사진은 올리는 즉시 업로드되지만, 위쪽 [편집영역 저장]을 눌러 새 버전으로 저장해야 고객 화면에
      반영됩니다. 사진을 바꾼 면은 표면·배치가 새 사진에서도 맞는지 확인해 주세요.
    </p>
  </aside>
);
